import { AppRegistry } from "Apps/AppRegistry";
import { Service } from "./ServiceApp.setting";
import { buildUrlFromQueryParam } from "Shared/Utils/QueryParameterUtils";

export const getServiceDetailLink = (serviceId: string): string => `${Service.path}/serviceid/${serviceId}`;

export const getServicePeopleLink = (alias: string): string => buildUrlFromQueryParam(Service.path, { alias });

export const getIcmTeamLink = (icmUrl: string, teamId: string): string => `${icmUrl}/imp/v3/administration/teamdashboard/oncall?id=${teamId}`;

export const getTeamLink = (teamId: string): string => `${AppRegistry.Teams.path}/${teamId}`;

export const getContactLink = (alias: string): string => `${AppRegistry.Contacts.path}/${alias}`;

export const getOICMaturityLink = (alias: string): string => `/SubstrateHubV2/OICMaturity/metrics?alias=${alias}`;

export const getSignalsHealthLink = (selectedSignals: string[], signalInFocus: string, duration: string) => {
    const encodedSignals = selectedSignals.map((signal) => encodeURI(signal)).join(";");
    return `/m365health/signalHealth?SelectedSignals=${encodedSignals}&SignalInFocus=${encodeURI(signalInFocus)}&Duration=${duration}`;
};

export const getOICOnboardingLink = (serviceId: string, icmPublicId: string, deploymentModel: string): string => {
    const path = "/SubstrateHubV2/Details/ScorecardManagement/OICOnboarding/serviceDetails/signalOnboarding";
    return buildUrlFromQueryParam(path, { serviceId, icmPublicId, deploymentModel });
};
export const getCMCustomerHubLink = "/customerhub/overview?CustomerHubOverviewCohort=CustomerMonitoring";
export const getCustomerIssuesLink = "/customerhub/customerIssues";
export const getSCPHubLink = (shdId: string): string => `/CustomerKnowledge/SCPHub/service-incidents/edit/${shdId}`;

export const getEnrichmentInsightsLink = (incidentId: string): string => `/incidents/${incidentId}/details/enrichmentInsights`;

export const getGatingCriteriaLink = (serviceId: string) => getServiceDetailLink(serviceId) + "/gatingCriteria";
